import { type User } from '@scoring/types';
import { Navigate, Outlet, useLocation } from 'react-router';

export const ProtectedOutlet = ({ user }: { user?: User }) => {
    const location = useLocation();
    if (user) return <Outlet />;
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
};

export default ProtectedOutlet;
